import React from 'react';
import MypageScheduleEditWrapper from 'components/MypageScheduleEditWrapper/MypageScheduleEditWrapper';

export default function MypageScheduleEditContainer() {
    return (
        <MypageScheduleEditWrapper />
    )
}
